import { panic } from "@opendaw/lib-std";
import { Pointers } from "@opendaw/studio-enums";
import { Devices } from "../../DeviceAdapter";
import { ModularAdapter } from "../../modular/modular";
import { DeviceInterfaceKnobAdapter } from "../../modular/user-interface";
export class ModularDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    parameterAt(_fieldIndices) { return panic("Not yet implemented"); }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    modular() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.modularSetup.targetVertex.unwrap("No Modular found").box, ModularAdapter);
    }
    elements() {
        return this.#box.userInterface.elements.pointerHub.filter(Pointers.DeviceUserInterface)
            .map(pointer => this.#context.boxAdapters.adapterFor(pointer.box, DeviceInterfaceKnobAdapter));
    }
    terminate() { }
}
